import React from 'react';

import { SimpleIcon } from './icon-utils';

export function NoSyncJobsIcon(): JSX.Element {
  return (
    <SimpleIcon fill="none" height="40" viewBoxDimensions="0 0 40 40" width="40">
      <path
        d="M33.1771 16.4059V11.6143C33.1771 10.9788 32.9247 10.3695 32.4754 9.92015C32.0261 9.47084 31.4167 9.21842 30.7813 9.21842H14.0104V6.82259C14.0104 6.18718 13.758 5.57779 13.3087 5.12848C12.8594 4.67918 12.25 4.42676 11.6146 4.42676H4.42708C3.79167 4.42676 3.18228 4.67918 2.73297 5.12848C2.28367 5.57779 2.03125 6.18718 2.03125 6.82259V32.8573C2.04027 33.5097 2.28389 34.137 2.71755 34.6245C3.15121 35.112 3.7459 35.427 4.3928 35.512C5.0397 35.5969 5.69556 35.4461 6.24036 35.087C6.78516 34.728 7.18247 34.1848 7.35958 33.5569L11.1147 18.1325C11.2597 17.634 11.5627 17.1962 11.978 16.8848C12.3934 16.5734 12.8987 16.4053 13.4178 16.4059H35.5729C35.9402 16.4058 36.3025 16.4901 36.632 16.6523C36.9615 16.8145 37.2493 17.0503 37.4731 17.3415C37.697 17.6326 37.8509 17.9713 37.923 18.3314C37.9951 18.6915 37.9834 19.0634 37.8889 19.4183L34.375 33.7933C34.2391 34.3037 33.9383 34.7548 33.5195 35.0766C33.1006 35.3984 32.5872 35.5728 32.059 35.5726H4.74174"
        stroke="#424B54"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SimpleIcon>
  );
}
